module.exports = __webpack_public_path__ + "img/bnr_camplist.c5cd5bce.png";